import request from '@/config/axios'

export interface LiveRelayOrderVO {
  id?: number
  relayId?: number
  liveId?: number
  buyerUserId?: number
  sellerUserId?: number
  price?: number
  payStatus?: number
  payChannel?: string
}

export const pageRelayOrder = (params: any) => request.get({ url: '/live/relay-order/page', params })
export const getRelayOrder = (id: number) =>
  request.get({ url: '/live/relay-order/get', params: { id } })
export const markRelayOrderPaid = (data: { paySn: number; payChannel: string }) =>
  request.post({ url: '/live/relay-order/mark-paid', data })
